import './App.css';
import { AllCommentsContextProvider } from './context/allComentsContext';
import MainPageComponent from './pages/mainPageComponent/mainPageComponent';
import 'bootstrap/dist/css/bootstrap.min.css';
import ThemeContextProvider from './context/themeContext';
function App() {
  return (
    <ThemeContextProvider>
      <AllCommentsContextProvider>
        <MainPageComponent />
      </AllCommentsContextProvider>
    </ThemeContextProvider>
  );
}

export default App;
